































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { VHover, VListItem } from 'vuetify/lib';
import { mapState, mapMutations } from 'vuex';
import AppService from '@/services/app';
import AuthService from '@/services/auth';

@Component({
  components: {
    AppBarItem: {
      render(h: any) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }: any) => {
              return h(VListItem, {
                attrs: this.$attrs,
                class: {
                  'black--text': !hover,
                  'white--text secondary elevation-12': hover,
                },
                props: {
                  activeClass: '',
                  dark: hover,
                  link: true,
                  ...this.$attrs,
                },
              }, this.$slots.default);
            },
          },
        });
      },
    },
  },

  computed: {
    ...mapState(['drawer']),
  },
})
export default class DashboardAppBar extends Vue {

  // Makes a "value" a component prop with the default value of false
  @Prop({default: false})
  value: boolean = false;

  setDrawer(val: any) {
    AppService.setDrawer(val);
  }

  logout() {
    AuthService.logout();  
  }
}
